import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Subject } from 'rxjs';
import { LADAAT_SERVER } from 'src/environments/environment';
import { Answer } from '../modules/settings/test/test.component';
import { PermissionsToRoutes } from './permissionsToAllRoutes.service';
export class responseM {
  massege: string = ""
  status: string = ""
  details?: any
  buttens?: any[]
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  emitRespons: Subject<responseM> = new Subject()

  $emitsendReq = new Subject<void>()
  $emitGetData = new Subject<void>()

  constructor(public http: HttpClient) { }

  emitsendReq() {
    this.$emitsendReq.next()
  }

  emitGetData() {
    this.$emitGetData.next()
  }

  getAllCat() {
    return this.http.get(LADAAT_SERVER + 'categories')
  }

  customSearchFn(term: any, item: any) {
    if (!term)
      return true
    term = term.split(';');
    return term.some((i: any, index: number) => {
      if (i && index == term.length - 1)
        return item.name.indexOf(i) > -1
      return item.name == i
    }
    )


  }

  getMasseges() {
    return this.http.get(LADAAT_SERVER + '/sub-category-contents-message')
  }

  getAllScores() {
    return this.http.get(LADAAT_SERVER + 'user/history')
  }

  getUser() {
    return this.http.get(LADAAT_SERVER + 'userD')

  }

  getAllUsersMakeTest(testId: string) {
    return this.http.get(LADAAT_SERVER + "loto-users/" + testId)
  }

  importUsers(path: string) {
    return this.http.get(LADAAT_SERVER + 'usersAnsFromYemot?path=' + path)
  }

  getTest(id: number) {
    return this.http.get(LADAAT_SERVER + 'sub-category-contents-test/' + id)
  }

  resetTest(id: number) {
    return this.http.get(LADAAT_SERVER + `resetTestUser/${id}`)
  }

  getContent(id: number) {
    return this.http.get(LADAAT_SERVER + `sub-category-contents/${id}`)
  }
  getAllSubCat(idCat: number) {
    return this.http.get(LADAAT_SERVER + `/categories/${idCat}/sub`)
  }

  getContByFilersTag(ids: number[], user: any) {

    user = user ? '-user' : ''

    return this.http.post(LADAAT_SERVER + 'contents-by-content-tags' + user, ids)
  }

  saveUserAns(userAns: any, idTest: number) {
    return this.http.post(LADAAT_SERVER + `user-ans/${idTest}`, userAns)
  }

  addToFavorite(cont: any) {
    return this.http.post(LADAAT_SERVER + `favorites`, cont)
  }


  getFavorite() {
    return this.http.get(LADAAT_SERVER + `favorites`).pipe(map((i: any) => {

      let allSubCat = []
      for (let s of i) {
        let subCat = s.subCategoryContent
        delete s.subCategoryContent
        subCat.favorites = [s]
        allSubCat.push(subCat)

      }
      return allSubCat
    }))
  }

  getSubCategoriesFile() {
    const filter = {
      where: {
        allowSubsribe: true,
      }
    };
    return this.http.get(LADAAT_SERVER + `sub-categories-userSubs?filter=${encodeURIComponent(JSON.stringify(filter))}`)
  }

  toggleSubscription(subId:number)
  {
    return this.http.post(LADAAT_SERVER+'user-subscriptions',{subCategoryId:subId})
  }


  calculateTest(user_ans: any, idTest: number) {
    return this.http.post(LADAAT_SERVER + `calculate-test/${idTest}`, user_ans)
  }

  getTestWithAnswer(id: number) {
    return this.http.get(LADAAT_SERVER + `get-result-test/${id}`)
  }

  get(url: string) {
    console.log(url);

    return this.http.get(LADAAT_SERVER + url)
  }

  delUser(id: number) {
    return this.http.delete(LADAAT_SERVER + `users/${id}`)
  }



  upUser(id: number, data: any) {
    return this.http.patch(LADAAT_SERVER + `users/${id}/admin`, data)

  }

  getTestForUser(id: number) {
    return this.http.get(LADAAT_SERVER + `sub-category-contents-test-user/${id}`)
  }
  update(url: string, body: any) {
    console.log(url);

    return this.http.patch(LADAAT_SERVER + url, body).pipe(
      // Handling the response with `map`
      map((response: any) => {
        if (!response || response.data == undefined) {
          return { data: response }
        }
        return response
      }))
  }
  del(url: string) {
    console.log(url);

    return this.http.delete(LADAAT_SERVER + url)
  }
  create(url: string, body: any) {
    console.log(url);

    return this.http.post(LADAAT_SERVER + url, body).pipe(
      // Handling the response with `map`
      map((response: any) => {

        if (!response || !response.data) {
          return { data: response }
        }
        return response
      })
    )
  }

  getCurrentCont(id: number) {
    return this.http.get(LADAAT_SERVER + `sub-categories/${id}/content-current`)
  }

  getFile(name: string) {
    return this.http.get(LADAAT_SERVER + `files/${name}`, {
      observe: 'response',
      responseType: (('blob') as any) as 'json'
    })
  }

  delFile(fileName: string) {
    return this.http.delete(LADAAT_SERVER + `/files/${fileName}`)
  }

  getCont(id: number) {
    return this.http.get(LADAAT_SERVER + `/sub-categories/${id}/cont`)

  }
  getAllFilters(id: number) {
    return this.http.get(LADAAT_SERVER + `/sub-categories/${id}/tags`)

  }
}
